import { defineMessages } from 'react-intl'

export default defineMessages({
  usFooterTitle: {
    id: 'us.footer.title',
    defaultMessage: 'More from Babylon',
  },
  usFooterPrivacyPolicy: {
    id: 'us.footer.privacy_policy',
    defaultMessage: 'Privacy Policy',
  },
  usFooterHIPAANotice: {
    id: 'us.footer.hipaa_notice',
    defaultMessage: 'HIPAA Privacy Notice',
  },
  usFooterPress: {
    id: 'us.footer.press',
    defaultMessage: 'Press',
  },
  usFooterCareers: {
    id: 'us.footer.careers',
    defaultMessage: 'Careers',
  },
  usFooterContact: {
    id: 'us.footer.contact',
    defaultMessage: 'Contact',
  },
  usFooterSiteMap: {
    id: 'us.footer.sitemap',
    defaultMessage: 'Site map',
  },
  usFooterFAQs: {
    id: 'us.footer.faqs',
    defaultMessage: 'FAQs',
  },
  usFooterLegal: {
    id: 'us.footer.legal',
    defaultMessage: 'Legal',
  },
  usFooterBlog: {
    id: 'us.footer.blog',
    defaultMessage: 'Blog',
  },
  usFooterShare: {
    id: 'us.footer.share',
    defaultMessage: 'Share',
  },
  usFooterAllRightsReserved: {
    id: 'us.footer.rights_reserved',
    defaultMessage: 'Babylon {year} - All rights reserved',
  },
  usFooterMadeWith: {
    id: 'us.footer.made_with',
    defaultMessage: 'Made with',
  },
})
